import { easeOut, Variants } from "framer-motion";

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      delay: i * 0.2,
      ease: easeOut,
    },
  }),
};

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: easeOut,
      delay: i * 0.08 + 0.1,
    },
  }),
};

// --- Book a Session (home) reveals ---
// Fade + rise, staggered by a `custom` index.
export const rise: Variants = {
  hidden: { opacity: 0, y: 40 },
  show: (i: number = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: easeOut, delay: i * 0.08 },
  }),
};

// Opacity-only reveal, staggered by a `custom` index. Used where a transform
// would disturb layout other code measures — e.g. the CapabilityWeb connectors,
// whose geometry is read from card rects that a translate-in would offset.
export const fade: Variants = {
  hidden: { opacity: 0 },
  show: (i: number = 0) => ({
    opacity: 1,
    transition: { duration: 0.5, delay: i * 0.08 },
  }),
};

// Parent container that staggers a word-by-word headline reveal.
export const wordStagger: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.05, delayChildren: 0.15 } },
};

// A single headline word rising in from below its clip mask.
export const word: Variants = {
  hidden: { opacity: 0, y: "100%" },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: easeOut } },
};

// --- Modal content reveals ---
// Rows easing in under a modal's headline, staggered by a `custom` index.
// Shares the [0.22, 1, 0.36, 1] curve the team panels use.
export const modalRow: Variants = {
  hidden: { opacity: 0, y: 14 },
  visible: (i: number = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      delay: 0.25 + i * 0.07,
      ease: [0.22, 1, 0.36, 1],
    },
  }),
};

// Parent that reveals its children one after another, rather than every card
// firing the moment the grid enters the viewport.
export const cardStagger: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.08 } },
};

export const cardRise: Variants = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: easeOut } },
};

// A grid cell easing in on a per-cell delay. The step is deliberately tiny —
// a schedule grid runs to 30 cells, so anything slower finishes after the
// reader has already scrolled past it.
export const gridCellRise: Variants = {
  hidden: { opacity: 0, y: 10 },
  show: (i: number = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.022, ease: easeOut },
  }),
};
